/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from '../client/http-client';
import {
  type CursorPaginationResponseDtoSbtTemplatePaginationResponseDto,
  type ErrorResponseDto,
  type OffsetPaginationResponseDtoSbtTemplatePaginationResponseDto,
  type SbtTemplateCreateRequestDto,
  type SbtTemplateResponseDto,
  type SbtTemplateUpdateRequestDto,
  type SuccessIdResponseDto,
} from '../dto/data-contracts';

export class SbtTemplate<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 배지 템플릿 전체 조회
   *
   * @tags SbtTemplate
   * @name GetAllSbtTemplateByOffset
   * @summary 배지 템플릿 전체 조회 (오프셋)
   * @request GET:/v1/admin/sbt-templates
   * @secure
   */
  getAllSbtTemplateByOffset = (
    query?: {
      /** 활성화 여부 */
      activeType?: 'ALL' | 'ACTIVE' | 'INACTIVE';
      /** 생성자 ID */
      creatorId?: string;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      /** 배지명 */
      search?: string;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      /** @default "RECENT" */
      sortField?: 'RECENT';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoSbtTemplatePaginationResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/admin/sbt-templates`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 배지 템플릿 생성
   *
   * @tags SbtTemplate
   * @name CreateSbtTemplate
   * @summary 배지 템플릿 생성
   * @request POST:/v1/admin/sbt-templates
   * @secure
   */
  createSbtTemplate = (
    data: SbtTemplateCreateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/admin/sbt-templates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 배지 템플릿 삭제
   *
   * @tags SbtTemplate
   * @name DeleteSbtTemplate
   * @summary 배지 템플릿 삭제
   * @request DELETE:/v1/admin/sbt-templates/{id}
   * @secure
   */
  deleteSbtTemplate = (id: string, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponseDto>({
      path: `/v1/admin/sbt-templates/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description 배지 템플릿 수정
   *
   * @tags SbtTemplate
   * @name UpdateSbtTemplate
   * @summary 배지 템플릿 수정
   * @request PATCH:/v1/admin/sbt-templates/{id}
   * @secure
   */
  updateSbtTemplate = (
    id: string,
    data: SbtTemplateUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/admin/sbt-templates/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 배지 템플릿 전체 조회
   *
   * @tags SbtTemplate
   * @name GetAllSbtTemplateByCursor
   * @summary 배지 템플릿 전체 조회 (커서)
   * @request GET:/v1/sbt-templates
   * @secure
   */
  getAllSbtTemplateByCursor = (
    query?: {
      /** 활성화 여부 */
      activeType?: 'ALL' | 'ACTIVE' | 'INACTIVE';
      /** 생성자 ID */
      creatorId?: string;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** 배지명 */
      search?: string;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      /** @default "RECENT" */
      sortField?: 'RECENT';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoSbtTemplatePaginationResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/sbt-templates`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 배지 템플릿 조회
   *
   * @tags SbtTemplate
   * @name GetSbtTemplate
   * @summary 배지 템플릿 조회
   * @request GET:/v1/sbt-templates/{id}
   */
  getSbtTemplate = (id: string, params: RequestParams = {}) =>
    this.http.request<SbtTemplateResponseDto, ErrorResponseDto>({
      path: `/v1/sbt-templates/${id}`,
      method: 'GET',
      ...params,
    });
}
